import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { ModuleMenu, INSTRUCTION } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsSummaryService } from '../../../services/grants/grants-summary.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-submit-instructions-modal',
  templateUrl: './submit-instructions-modal.component.html',
  styleUrls: ['./submit-instructions-modal.component.scss']
})
export class SubmitInstructionsModalComponent implements OnInit {

  id: number;
  isAck = false;
  menudata: ModuleMenu;
  instruction: INSTRUCTION;
  title: string = "";
  description: string = "";
  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private router: Router,
    private dataShare: IstDataShareService,
    private header: HeadService,
    private summaryService: GrantsSummaryService,
  ) { }

  ngOnInit() {
    this.getGrantsInstructions();
  }

  add() {
    this.modalRef.dismiss();
    this.dataShare.setApplicationID("");
    this.menudata = new ModuleMenu();
    this.menudata.module = "IST";
    this.menudata.operation = "New";
    this.menudata.appId = "";
    this.menudata.formstate = "Draft";

    this.header.setHeader(this.menudata);
    this.router.navigate(['/home/ist/my-applications/application-ext/:0/general_information_request'], {skipLocationChange:true, queryParams:{id:"", app_ext:true, module:"ist", screen_type:"my-applications" }});
  }

  getGrantsInstructions() {
    let instructionid = "2"
    this.summaryService.getInstruction(instructionid).subscribe(summary => {
      this.instruction = summary;
      if (this.instruction != null) {
        this.title = this.instruction.NAME;
        this.description = this.instruction.DESCRIPTION;
      }

    });
  }
}
